import React from 'react'

import NewUser from './NewUser'
import BackButton from '../UI/BackButton'
import PageTitle from '../UI/PageTitle'


const NewUserPage = () => (
  <section>
    <header>
      <PageTitle>New User</PageTitle>
    </header>
    <NewUser showSuccessDialog={true} />
    <br/>
    <BackButton/>
  </section>
)

export default NewUserPage



// WEBPACK FOOTER //
// ./src/components/Users/NewUserPage.jsx